import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiCall } from '../utils/api';

function IncidentView() {
  const navigate = useNavigate();
  const [incidentNumber, setIncidentNumber] = useState('');
  const [incidentDescription, setIncidentDescription] = useState('');
  const [tribeInformation, setTribeInformation] = useState('');
  const [classificationResult, setClassificationResult] = useState(null);
  const [isProceedEnabled, setIsProceedEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleClassify = async () => {
    if (!incidentNumber || !incidentDescription || !tribeInformation) {
      alert("Please fill out all incident fields before classifying.");
      return;
    }
    setIsLoading(true); // Show loading state
    try {
      const data = await apiCall("/classify", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          incident_number: incidentNumber,
          incident_description: incidentDescription,
          tribe: tribeInformation,
        }),
      });
      if (data.error) {
        alert(data.error);
      } else {
        setClassificationResult(data);
        setIsProceedEnabled(false); // Reset button to disabled on new classification
      }
    } catch (error) {
      console.error("Classification Error:", error);
      alert("An error occurred during classification.");
    } finally {
      setIsLoading(false); // Hide loading state
    }
  };

  const handleFeedback = async (feedback) => {
    if (!classificationResult) return;
    try {
      // Map UI feedback to Lambda expected values
      const topicFeedback = feedback === "Helpful" ? "Correct" : "Incorrect";
      
      const data = await apiCall("/feedback", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          incident_number: classificationResult.incident_number,
          topic_feedback: topicFeedback,
        }),
      });
      if (data.success) {
        if (feedback === "Helpful") {
          alert("Thanks for your feedback!");
          setIsProceedEnabled(true); // Enable the proceed button
        } else {
          alert("Thank you for your feedback. Your input helps us improve.");
          setClassificationResult(null); // Reset the view
        }
      } else {
        alert("Error submitting feedback.");
      }
    } catch (error) {
      console.error("Feedback Error:", error);
      alert("An error occurred while submitting feedback.");
    }
  };

  const handleGoToResolution = () => {
    if (classificationResult) {
      const { predicted_runbook, incident_number } = classificationResult;
      navigate(`/resolution?runbook_id=${predicted_runbook}&module_index=0&incident_number=${incident_number}`);
    }
  };

  return (
    <div className="container mt-4">
      <h1>Incident Details</h1>

      <form id="incidentForm" className="card p-4 mb-4">
        <div className="mb-3">
            <label htmlFor="incident_number" className="form-label">Enter Incident Number:</label>
            <input
              type="text"
              id="incident_number"
              className="form-control"
              value={incidentNumber}
              onChange={(e) => setIncidentNumber(e.target.value)}
              required
            />
        </div>

        <div className="mb-3">
            <label htmlFor="incident_description" className="form-label">Enter Short Description:</label>
            <input
              type="text"
              id="incident_description"
              className="form-control"
              value={incidentDescription}
              onChange={(e) => setIncidentDescription(e.target.value)}
              required
            />
        </div>

        <div className="mb-3">
            <label htmlFor="tribe_information" className="form-label">Select Tribe Information:</label>
            <select
              id="tribe_information"
              className="form-select"
              value={tribeInformation}
              onChange={(e) => setTribeInformation(e.target.value)}
              required
            >
              <option value="" disabled>Select a Tribe</option>
              <option value="KRM">KRM</option>
              <option value="PRM">PRM</option>
              <option value="BOI">BOI</option>
              <option value="OSFM">OSFM</option>
              <option value="DML">DML</option>
            </select>
        </div>
        
        <button type="button" className="btn btn-primary" onClick={handleClassify} disabled={isLoading}>
          {isLoading ? 'Classifying...' : 'Classify'}
        </button>
      </form>

      {classificationResult && (
        <div id="classificationResult" className="card p-4">
          <h2>Classification Result</h2>
          <p><strong>Incident Number:</strong> {classificationResult.incident_number}</p>
          <p><strong>Predicted Topic:</strong> {classificationResult.predicted_topic}</p>
          <p><strong>Topic Terms:</strong> {classificationResult.topic_terms}</p>
          <p><strong>Predicted Runbook:</strong> {classificationResult.predicted_runbook}</p>
          <p><strong>Runbook Title:</strong> {classificationResult.runbook_title}</p>
          <hr />
          <div id="feedbackSection">
            <p className="mb-2"><strong>Was the classification helpful?</strong></p>
            <div className="d-flex gap-2">
                <button type="button" className="btn btn-success" onClick={() => handleFeedback("Helpful")}>Helpful</button>
                <button type="button" className="btn btn-danger" onClick={() => handleFeedback("Not Helpful")}>Not Helpful</button>
            </div>
          </div>

          <hr />
          <button
            type="button"
            id="goToResolution"
            className={`btn ${!isProceedEnabled ? 'disabled-button' : 'btn-primary'}`}
            disabled={!isProceedEnabled}
            onClick={handleGoToResolution}
          >
            Proceed to Resolution
          </button>
        </div>
      )}
    </div>
  );
}

export default IncidentView;